<div class="mw-100" style="background-color: white; height: 100%;">
    <app-navbar></app-navbar>
    <div class="container">
      <div class="row">
          <div class="col">
            <div class="device-selection-header" (click)="showDevice()">
              <span class="elegirDispositivo">
                {{ 'CHOOSE_DEVICE' | translate}}
                <span class="device-status-badge" [ngClass]="{'selected': deviceName}">
                  {{ deviceName ? (('SELECTED' | translate) + ': ' + deviceName) : ('NOT_SELECTED' | translate) }}
                </span>
                <i [ngClass]="dev ? 'pi pi-angle-up' : 'pi pi-angle-down'" class="icnCstColor"></i>
              </span>
            </div>
            <div *ngIf="dev" class="device-dropdown">
              <ul>              
                  <li *ngFor="let device of filteredDevices" 
                      (click)="seleccionarDispositivo(device)" 
                      class="device-item" 
                      [ngClass]="{'device-selected': device.selected, 'device-deselected': !device.selected}">
                    {{device.nombre}} - {{device.token}}
                  </li>
              </ul>
            </div> 
            <!--<h5 class="customFont1" *ngIf="deviceName">{{ 'DEVICE' | translate}} {{deviceName}}</h5>
            <h5 class="customFont1" *ngIf="deviceUrl">{{ 'TOKEN_CAMPAIGNS' | translate}} {{deviceUrl}}</h5>-->
          </div>
      </div>
      <div class="p-grid">
        <div class="p-col-4">
          <a (click)="envioMasivoMensaje(deviceUrl, deviceName)" style="cursor: pointer;">
          <p-card>
            <div class="p-grid card-content">
              <div class="p-col-4">
                <!-- Lado izquierdo del card con el icono -->
                <i class="icon-container">
                  <img src="assets/message-2-64.png" class="img-fluid rounded-start" alt="Icono">
                </i>
              </div>
              <div class="p-col-8">
                <!-- Lado derecho del card con el título -->
                <div class="card-body">
                  <h5 class="customFont3">{{ 'MESSAGE_MULTIPLE_CONTACTS' | translate}}</h5>
                </div>
              </div>
            </div>
          </p-card>
        </a>
        </div>
  
        <div class="p-col-4">
          <a (click)="envioMasivoArchivo(deviceUrl, deviceName)" style="cursor: pointer;">
          <p-card>
            <div class="p-grid card-content">
              <div class="p-col-4">
                <!-- Lado izquierdo del card con el icono -->
                <i class="icon-container">
                  <img src="assets/text-file-4-64.png" class="img-fluid rounded-start" alt="Icono">
                </i>
              </div>
              <div class="p-col-8">
                <!-- Lado derecho del card con el título -->
                <div class="card-body">
                  <h5 class="customFont3">{{ 'FILE_MULTIPLE_CONTACTS' | translate}}</h5>
                </div>
              </div>
            </div>
          </p-card>
        </a>
        </div>
  
        <div class="p-col-4">
          <a (click)="mensajePersonalizadoGrupo(deviceUrl, deviceName)" style="cursor: pointer;">
          <p-card>
            <div class="p-grid card-content">
              <div class="p-col-4">
                <!-- Lado izquierdo del card con el icono -->
                <i class="icon-container">
                  <img src="assets/message-2-64.png" class="img-fluid rounded-start" alt="Icono">
                </i>
              </div>
              <div class="p-col-8">
                <!-- Lado derecho del card con el título -->
                <div class="card-body">
                  <h5 class="customFont3">{{ 'PERSONALIZED_MESSAGE_MULTIPLE_CONTACTS' | translate}}</h5>
                </div>
              </div>
            </div>
          </p-card>
        </a>
        </div>

        <div class="p-col-4">
          <a (click)="archivoPersonalizadoGrupo(deviceUrl, deviceName)" style="cursor: pointer;">
          <p-card>
            <div class="p-grid">
              <div class="p-col-4 card-content">
                <!-- Lado izquierdo del card con el icono -->
                <i class="icon-container">
                  <img src="assets/message-2-64.png" class="img-fluid rounded-start" alt="Icono">
                </i>
              </div>
              <div class="p-col-8">
                <!-- Lado derecho del card con el título -->
                <div class="card-body">
                  <h5 class="customFont3">{{ 'PERSONALIZED_FILE_MULTIPLE_CONTACTS' | translate}}</h5>
                </div>
              </div>
            </div>
          </p-card>
        </a>
        </div>

        <div class="p-col-4">
          <a (click)="listaDeContactos(deviceUrl, deviceName)" style="cursor: pointer;">
          <p-card>
            <div class="p-grid">
              <div class="p-col-4 card-content">
                <!-- Lado izquierdo del card con el icono -->
                <i class="icon-container">
                  <img src="assets/text-file-4-64.png" class="img-fluid rounded-start" alt="Icono">
                </i>
              </div>
              <div class="p-col-8">
                <!-- Lado derecho del card con el título -->
                <div class="card-body">
                  <h5 class="customFont3">{{ 'CONTACT_LIST' | translate}}</h5>
                </div>
              </div>
            </div>
          </p-card>
          </a>
        </div>

        <div class="p-col-4">
          <a (click)="myCampaigns(deviceUrl, deviceName)" style="cursor: pointer;">
          <p-card>
            <div class="p-grid">
              <div class="p-col-4 card-content">
                <!-- Lado izquierdo del card con el icono -->
                <i class="icon-container">
                  <img src="assets/telegram-2-64.png" class="img-fluid rounded-start" alt="Icono">
                </i>
              </div>
              <div class="p-col-8">
                <!-- Lado derecho del card con el título -->
                <div class="card-body">
                  <h5 class="customFont3">{{ 'CAMPAIGNS' | translate}}</h5>
                </div>
              </div>
            </div>
          </p-card>
          </a>
        </div>
      </div>
    </div>
  </div>